import { Box, Container, Typography } from '@mui/material'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { sendContactUs } from '../../../../../redux/actions/help'
import { IRootState } from '../../../../../redux/types'
import ButtonBack from '../../../../shared/components/buttons/ButtonBack'
import Hero from '../components/Hero'
import ContactFormField from '../components/contactForm/ContactFormField'
import FileUploader from '../components/contactForm/FileUploader'
import SubmitButton from '../components/contactForm/SubmitButton'
import TopicSelector from '../components/contactForm/TopicSelector'
import { useContactForm } from '../hooks/useContactForm'

const ContactForm = () => {
  const { t } = useTranslation(['helpcenter'])
  const dispatch = useDispatch()
  const { reload } = useSelector((state: IRootState) => state.help)
  const { isValidForm } = useSelector((state: IRootState) => state.validator)

  const { contactUs, setContactUs, topics, handleSelectChange, handleInputChange, getUploadParams, handleSubmit, msgForm, errorForm } =
    useContactForm(t, dispatch)

  useEffect(() => {
    if (isValidForm) {
      dispatch(sendContactUs({ ...contactUs, topic: topics.find((topic: any) => topic.id === contactUs.topic) }))
      setContactUs({
        topic: null,
        email: '',
        name: '',
        subject: '',
        message: '',
        filesName: []
      })
    }
  }, [isValidForm, dispatch, topics, contactUs, setContactUs])

  useEffect(() => {
    if (reload) {
      window.location.reload()
    }
  }, [reload])

  return (
    <Container sx={{ padding: 0 }} maxWidth="xl">
      <Hero />
      <Container maxWidth="sm">
        <Box mt={6}>
          <ButtonBack />
        </Box>
        <Box display="grid" my={3} sx={{ gap: 8 }}>
          <Typography sx={{ fontWeight: 500 }} variant="h5">
            {t('contactUs.contacttl')}
          </Typography>
          <Typography color="text.secondary">{t('contactUs.contacttx')}</Typography>
        </Box>

        <TopicSelector
          topics={topics}
          selectedTopic={contactUs.topic}
          onChange={handleSelectChange}
          errorMessage={msgForm.topic}
          label={t('contactUs.choice')}
        />

        <ContactFormField
          label={t('contactUs.email')}
          placeholder={t('contactUs.emailph')}
          value={contactUs.email}
          onChange={handleInputChange('email')}
          error={errorForm.email}
          helperText={msgForm.email}
          ariaLabel="email"
        />

        <ContactFormField
          label={t('contactUs.fullname')}
          placeholder={t('contactUs.fullnameph')}
          value={contactUs.name}
          onChange={handleInputChange('name')}
          error={errorForm.name}
          helperText={msgForm.name}
          ariaLabel="name"
        />

        <ContactFormField
          label={t('contactUs.subject')}
          placeholder={t('contactUs.subjectph')}
          value={contactUs.subject}
          onChange={handleInputChange('subject')}
          error={errorForm.subject}
          helperText={msgForm.subject}
          secondaryHelperText={t('contactUs.subjectht')}
          ariaLabel="subject"
        />

        <ContactFormField
          label={t('contactUs.message')}
          placeholder={t('contactUs.messageph')}
          value={contactUs.message}
          onChange={handleInputChange('message')}
          error={errorForm.message}
          helperText={msgForm.message}
          secondaryHelperText={t('contactUs.messageht')}
          ariaLabel="message"
          multiline
          rows={4}
        />

        <FileUploader getUploadParams={getUploadParams} label={t('contactUs.addimage')} dropzoneText={t('contactUs.dropzone-text')} />

        <SubmitButton onClick={handleSubmit} label={t('send')} />
      </Container>
    </Container>
  )
}

export default ContactForm
